<template>
    <div class="caseSharing">
      <TopNavigation :TopAct="'1'"/>
      <div :class="this.$store.state.webNavigator=='pc'?'':'pan110'">
        <listTopImg :imgType="'1'"/>
        <div :class="this.$store.state.webNavigator=='pc'?'max1720':''" class=" marginAuto" >
          <articlePage  :listType="'A10'"
                        :titles="'案例分享'"
                        :pageIndex="current"
                        :navLsit="navList"
                        :active="types"
                        :key="keys"
                        :toLeveListPath="toLeveListPath"
                        @getTotal="getTotal"
          />
          <Pagination :total="total" :display="12" :current-page='current' @pagechange="getPage"/>
        </div>
      </div>
      <FooterNavigation />
    </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import articlePage from '../listPage/articlePage/articlePage';
import listTopImg from '../../components/listTopImg/listTopImg';
import Pagination from '../../components/Pagiantion/Pagination';
export default {
  name: 'caseSharing',
  components: {TopNavigation, FooterNavigation, articlePage, listTopImg, Pagination, },
  title () {
    return {
      title: '减肥案例|减肥案例视频|减脂案例-脂玫乐(谷医坊)',
      keywords: '减肥案例，瘦身案例，减脂案例，减肥视频',
      description: '脂玫乐减肥案例，为用户提供减肥真实案例，瘦身案例与减脂案例视频。',
    };
  },
  data () {
    return {
      keys: 1,
      total: 1,
      current: 1,
      types: '1',
      navList: [
        {
          code: '',
          pid: 54,
          id: 0,
          text: '案例视频',
          type: '1',
        }, {
          code: '',
          pid: 54,
          id: 0,
          text: '案例分享',
          type: '2',
        },
      ],
      toLeveListPath: 'caseSharing',
    };
  },
  watch: {
    $route () {
      this.current = parseInt(this.$route.params.html.split("-")[1]);
      this.keys += 1;
    },
  },
  methods: {
    getTotal (data) {
      this.total = data;
    },
    getPage (data) {
      this.$router.push({path: '/' + this.$route.path.split('/')[1] + '/' + this.$route.params.html.split("-")[0] + '-' + data + '-' + this.$route.params.html.split("-")[2] });
    },
  },
  mounted () {
    this.current = parseInt(this.$route.params.html.split("-")[1]);
    this.keys += 1;
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../static/css/fontSize.less');
 .caseSharing-main{
   padding-top: 40*@width;
 }
</style>



// WEBPACK FOOTER //
// caseSharing.vue